import { createSelector } from 'reselect';

import { selectBranchesDictionary } from 'app/dealer/account/Branches/selectors';

export const getLevelReducer = ({ dealersInsights }) => dealersInsights.level;

export const selectCurrentLevel = createSelector(
  [getLevelReducer],
  ({ currentLevel }) => currentLevel,
);
export const selectCurrentDealerId = createSelector(
  [getLevelReducer],
  ({ currentDealerId }) => currentDealerId,
);
export const selectCurrentDealer = createSelector(
  [selectBranchesDictionary, selectCurrentDealerId],
  (branchesDictionary, id) => branchesDictionary[id],
);
